import { navigationURLv2 } from 'endpoints';
import { fetch } from '@nackle/studio-tools';
import { message } from '@nackle/paper';

export const apiGetMenuTypeDefinition = async ( menuType ) => {
    const res = await fetch(
        `${ navigationURLv2 }/menus/${ menuType }/company`, {
            method: 'GET',
            headers: {
                'content-type': 'application/json'
            }
        }
    );
    const data = await res.json();
    if ( res.ok ) {
        return data;
    } else {
        throw data;
    }
};

export const apiUpdateMenuDefinition = async ( menuData ) => {
    const res = await fetch(
        `${ navigationURLv2 }/menus`, {
            method: 'PUT',
            headers: {
                'content-type': 'application/json'
            },
            body: JSON.stringify( { ...menuData } )
        }
    );
    const data = await res.json();
    if ( res.ok ) {
        message.success( 'Menu saved.' );
        return data;
    } else {
        message.error( 'Unable to save menu.' );
        throw data;
    }  
};

export const apiCreateMenuDefinition = async ( menuData ) => {
    const res = await fetch(
        `${ navigationURLv2 }/menus`, {
            method: 'POST',
            headers: {
                'content-type': 'application/json'
            },
            body: JSON.stringify( { ...menuData } )
        }
    );
    const data = await res.json();
    if ( res.ok ) {
        message.success( 'Menu created.' );
        return data;
    } else {
        message.error( 'unable to create menu' );
        throw data;
    }
};